import { z } from "zod";
import { TAccrualEventType } from "../accrualEventTypes";
import { schemes } from "../../schema-validation";
import { common } from "./common";

export const accrualSchema = z.object({
  employeeID: schemes.mongoObjectId(),
  effective_date: schemes.isoDate(),
  amount: z.number(),
});

export const accrual = z
  .object({
    employees: z.array(accrualSchema),
  })
  .merge(common);

export type AccrualUpdate = {
  updateOne: {
    filter: {
      companyID: string;
      policyID: string;
      employeeID: string;
    };
    update: {
      $set: {
        balance: number;
        accrued?: number;
      };
      $push?: {
        accrualEvents: {
          hours: number;
          type: TAccrualEventType;
          employeeCheckID: string;
          modified_by: string;
          timestamp: Date;
        };
      };
    };
  };
}[];
export type Accrual = z.infer<typeof accrual>;
export type EmployeeAccrual = z.infer<typeof accrualSchema>;
